import { inject } from '@angular/core';
import { CanActivateFn, Router, ActivatedRouteSnapshot } from '@angular/router';
import { AuthStore } from '../auth/auth.store';

export const RoleGuard: CanActivateFn = (route: ActivatedRouteSnapshot, state) => {
    const authStore = inject(AuthStore);
    const router = inject(Router);
    const isAuthenticated = authStore.isAuthenticated(); 
    const hasRole = authStore.hasRole();
    // First check if user is logged in
    if (!isAuthenticated) {
        // User is not logged in, redirect to login page
        router.navigate(['/login'], { queryParams: { returnUrl: state.url } });
        return false;
    }
    const requiredRoles = route.data['roles'] as string[];

    // If no roles are specified, allow access (just need to be authenticated)
    if (!requiredRoles || requiredRoles.length === 0) {
        return true;
    }

    // Check if user has any of the required roles
    const  isAuthorized = hasRole(requiredRoles);

    if (isAuthorized) {
        return true;
    } else {
        router.navigate(['/unauthorized']);
        return false;
    }
};
